import { useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  SwipeableDrawer,
  useMediaQuery,
} from "@material-ui/core";
import styled from "@emotion/styled";
import Image from "next/image";
import MenuIcon from "@material-ui/icons/Menu";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";

import { ButtonLink } from "@/components/Buttons/";
import Link from "@/components/Link";
import intercom from "@/services/intercom";
import Links from "@/constants/Links";
import { NavLinkButton } from "./Buttons/NavLinkButton";

const SupportButton = styled(Button)`
  text-transform: uppercase;
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
`;

export default function LandingHeader({
  ctaOutlined,
}: {
  ctaOutlined?: boolean;
}) {
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const [menuDrawerOpen, setMenuDrawerOpen] = useState(false);

  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const handleShareLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      enqueueSnackbar("Link copied.", {
        variant: "success",
      });
    } catch (err) {
      enqueueSnackbar("Failed to copy.", {
        variant: "error",
      });
    }
  };

  const renderMenu = () => (
    <Grid
      container
      spacing={6}
      alignItems="center"
      justifyContent="center"
      direction={isDesktop ? "row" : "column"}
    >
      <Grid item>
        <NavLinkButton route={Links.BLOG}>Blog</NavLinkButton>
      </Grid>
      <Grid item>
        <NavLinkButton route={Links.WHAT_IS_CYBER_INSURANCE}>
          What is cyber insurance?
        </NavLinkButton>
      </Grid>
      <Grid item>
        <SupportButton color="primary" onClick={intercom.show}>
          Support
        </SupportButton>
      </Grid>
      <Grid item>
        {router.pathname.indexOf(Links.APPLICATION) === 0 ? (
          <Button color="primary" variant="contained" onClick={handleShareLink}>
            Share Link
          </Button>
        ) : (
          <ButtonLink
            color="primary"
            variant={ctaOutlined ? "outlined" : "contained"}
            route={Links.QUOTE}
          >
            Get a Quote
          </ButtonLink>
        )}
      </Grid>
    </Grid>
  );

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={6}
        pt={2}
        pb={2}
        zIndex={100}
        boxShadow="0px 3px 15px 3px rgba(0, 0, 0, 0.08)"
        bgcolor="#ffffff"
      >
        <Link href="/">
          <Image
            src="/images/icon_with_name.png"
            alt="Getcyber.com"
            height={42}
            width={256}
          />
        </Link>

        <Box>
          {isDesktop ? (
            renderMenu()
          ) : (
            <IconButton onClick={() => setMenuDrawerOpen((pS) => !pS)}>
              <MenuIcon />
            </IconButton>
          )}
        </Box>
      </Box>
      <SwipeableDrawer
        open={menuDrawerOpen}
        onOpen={() => setMenuDrawerOpen(true)}
        onClose={() => setMenuDrawerOpen(false)}
        anchor="right"
      >
        <Box height="100%" padding={6}>
          {renderMenu()}
        </Box>
      </SwipeableDrawer>
    </>
  );
}
